import { render, staticRenderFns } from "./bindItemDialog.vue?vue&type=template&id=d106f44c&scoped=true&"
import script from "./bindItemDialog.vue?vue&type=script&lang=js&"
export * from "./bindItemDialog.vue?vue&type=script&lang=js&"
import style0 from "./bindItemDialog.vue?vue&type=style&index=0&id=d106f44c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d106f44c",
  null
  
)

export default component.exports